var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.96 2.05a8.91 8.91 0 0 1 8.912 8.912 8.87 8.87 0 0 1-2.202 5.86l4.105 4.105a.6.6 0 0 1-.848.848l-4.105-4.105a8.88 8.88 0 0 1-5.861 2.203 8.912 8.912 0 0 1 0-17.822m0 1.2a7.713 7.713 0 1 0 .002 15.425 7.713 7.713 0 0 0-.001-15.425"
  })));
};
export default SvgSearch;